import { render, staticRenderFns } from "./NewsListHot.vue?vue&type=template&id=0a7298f5"
import script from "./NewsListHot.vue?vue&type=script&lang=js"
export * from "./NewsListHot.vue?vue&type=script&lang=js"
import style0 from "./NewsListHot.vue?vue&type=style&index=0&id=0a7298f5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports